import { ApiParams, prepareBaseListApiParams } from '@/api/helpers/apiHelpers';
import { QueryParamsType } from '@/api/helpers/apiParamsHelpers';
import { prepareResponse, throwResponseError, withPreparedResponse } from '@/helpers/apiHelpers/responseHelpers';
import { getAuditEventsApi } from '@/api/v1/organization/audit-log/getAuditEventsApi';
import { getAuditEventApi } from '@/api/v1/organization/audit-log/getAuditEventApi';
import { getAuditCatalogApi } from '@/api/v1/organization/audit-log/getAuditCatalogApi';
import { exportAuditEventsApi } from '@/api/v1/organization/audit-log/exportAuditEventsApi';

export const AUDIT_LOG_QUERY_KEYS = {
  catalog: ['audit_log_catalog'],
  events: 'audit_log_events',
  event: 'audit_log_event',
} as const;

export type AuditFiltersType = QueryParamsType & {
  category?: string;
  source?: string;
  q?: string;
  date_from?: string;
  date_to?: string;
  request_id?: string;
  object_id?: string;
};

const FILTER_KEYS = ['category', 'source', 'q', 'date_from', 'date_to', 'request_id', 'object_id'];

const withFilters = (queryParams: AuditFiltersType, paginate = true) => {
  const params: ApiParams = paginate ? prepareBaseListApiParams(queryParams) : {};

  if (!paginate && queryParams?.ordering) params.ordering = queryParams.ordering;

  FILTER_KEYS.forEach((key) => {
    if (queryParams?.[key]) params[key] = queryParams[key];
  });

  return params;
};

export const loadAuditCatalog = () => withPreparedResponse(getAuditCatalogApi);
export const loadAuditEvents = (queryParams: AuditFiltersType) =>
  withPreparedResponse(() => getAuditEventsApi(withFilters(queryParams)));
export const loadAuditEvent = (id: string) => withPreparedResponse(() => getAuditEventApi(id));

export const exportAuditEvents = async (queryParams: AuditFiltersType) => {
  try {
    const response = await exportAuditEventsApi(withFilters(queryParams, false));

    return prepareResponse(response, ['Content-Disposition']);
  } catch (e) {
    throwResponseError(e);
  }
};
